import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stepper as MuiStepper, useMediaQuery, } from '@mui/material';
import { Children, cloneElement, useEffect, useRef, } from 'react';
import { useTheme } from '../../hooks';
import { styled } from '../../utils';
import { Typography } from '../Typography';
import { StepConnector } from './StepConnector';
import { StepNavigation } from './StepNavigation';
export const breakpointFallback = 'sm';
export function Stepper(props) {
    const { breakpoint = breakpointFallback, scrollOffset: scrollOffsetRaw, setScrollOffset, orientation, contentTitle, alternativeLabel, ...otherProps } = props;
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up(breakpoint));
    const scrollOffset = matches ? 10 : scrollOffsetRaw;
    useEffect(() => {
        if (setScrollOffset && scrollOffset) {
            setScrollOffset(scrollOffset);
        }
    }, [scrollOffset, setScrollOffset]);
    const stepperOrientation = !matches ? 'horizontal' : orientation;
    const children = Children.map(props.children, (child) => cloneElement(child, {
        breakpoint,
        scrollOffset,
        orientation: stepperOrientation,
        contentTitle,
        alternativeLabel,
        activeStep: props.activeStep,
    }));
    const StepperComponent = !matches || orientation === 'horizontal'
        ? StepperHorizontal
        : StepperVertical;
    return (_jsx(StepperComponent, { ...otherProps, orientation: stepperOrientation, alternativeLabel: alternativeLabel, breakpoint: breakpoint, scrollOffset: scrollOffset, contentTitle: contentTitle, children: children }));
}
// StepperHorizontal
function StepperHorizontal(props) {
    const { scrollOffset, forcedStep, setAnimating, contentTitle, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    breakpoint, stickyNavigation, ...otherProps } = props;
    const hasJustMountedRef = useRef(true);
    const labelRef = useRef(null);
    useEffect(() => {
        if (hasJustMountedRef.current) {
            hasJustMountedRef.current = false;
            return;
        }
        const element = labelRef.current;
        if (!element) {
            return;
        }
        if (setAnimating)
            setAnimating(false);
        if (!forcedStep) {
            const { top } = element.getBoundingClientRect();
            const { top: bodyTop } = document.body.getBoundingClientRect();
            const offsetPosition = top - bodyTop - (scrollOffset || 0);
            window.scrollTo({
                behavior: 'smooth',
                top: offsetPosition,
            });
        }
    }, [props.activeStep, forcedStep, scrollOffset, setAnimating]);
    const childrenArray = Array.isArray(props.children)
        ? props.children
        : [props.children];
    const childActive = childrenArray[props.activeStep || 0];
    return (_jsxs(StepperHorizontalRootStyled, { stickyNavigation: stickyNavigation, children: [_jsx(StepperHorizontalStyled, { ...otherProps }), _jsx(StepperHorizontalContentStyled, { stickyNavigation: stickyNavigation, children: _jsxs("div", { children: [contentTitle && (_jsx(StepperHorizontalLabelStyled, { ref: labelRef, variant: "h5", children: childActive?.props?.label })), childActive?.props.children] }) }), _jsx(StepNavigation, { sticky: stickyNavigation, index: otherProps.activeStep, ...childActive?.props })] }));
}
const StepperHorizontalRootStyled = styled('div', {
    shouldForwardProp: (prop) => prop !== 'stickyNavigation',
})(({ stickyNavigation }) => ({
    width: '100%',
    ...(stickyNavigation && {
        width: 'unset',
        display: 'flex',
        flexDirection: 'column',
    }),
}));
const StepperHorizontalContentStyled = styled('div', {
    shouldForwardProp: (prop) => prop !== 'stickyNavigation',
})(({ stickyNavigation }) => ({
    ...(stickyNavigation && {
        overflowY: 'auto',
    }),
}));
const StepperHorizontalStyled = styled(MuiStepper)(({ theme }) => ({
    padding: theme.spacing(2, 0, 3, 0),
}));
const StepperHorizontalLabelStyled = styled(Typography)(({ theme }) => ({
    paddingBottom: theme.spacing(2),
}));
// StepperVertical
function StepperVertical(props) {
    /* eslint-disable @typescript-eslint/no-unused-vars */
    const { scrollOffset, forcedStep, setAnimating, orientation, contentTitle, alternativeLabel, stickyNavigation, // TODO: not implemeted yet
    ...otherProps } = props;
    /* eslint-enable @typescript-eslint/no-unused-vars */
    return (_jsx(StepperVerticalStyled, { orientation: "vertical", connector: connectorVertical, ...otherProps }));
}
const StepperVerticalStyled = styled(MuiStepper)({
    padding: 0,
});
const connectorVertical = _jsx(StepConnector, {});
